import RB from '../images/RB.webp';
import RBV from '../images/RBV.webp';
import Haas from '../images/HAAS.webp';
import Audi from '../images/AUDI.webp';
import Mercedes from '../images/MERCEDES.webp';
import Ferrari from '../images/FERRARI.webp';
import Alpine from '../images/ALPINE.webp';
import Williams from '../images/WILLIAMS.webp';
import Cadillac from '../images/CADILLAC.webp';
import AstonMartin from '../images/ASTONMARTIN.webp';
import McLaren from '../images/MCLAREN.webp';

export const teamsData = [
    {
        team: "Red Bull Ford",
        color: "#3671C6",
        driver1: { flag: "🇳🇱", name: "Max Verstappen" },
        driver2: { flag: "🇫🇷", name: "Isack Hadjar" },
        teamPrincipal: "Laurent Mekies",
        image: RB,
        launchDate: ""
    },
    {
        team: "Ferrari",
        color: "#E8002D",
        driver1: { flag: "🇲🇨", name: "Charles Leclerc" },
        driver2: { flag: "🇬🇧", name: "Lewis Hamilton" },
        teamPrincipal: "Frédéric Vasseur",
        image: Ferrari,
        launchDate: ""
    },
    {
        team: "McLaren",
        color: "#FF8000",
        driver1: { flag: "🇬🇧", name: "Lando Norris" },
        driver2: { flag: "🇦🇺", name: "Oscar Piastri" },
        teamPrincipal: "Andrea Stella",
        image: McLaren,
        launchDate: ""
    },
    {
        team: "Mercedes",
        color: "#27F4D2",
        driver1: { flag: "🇬🇧", name: "George Russell" },
        driver2: { flag: "🇮🇹", name: "Kimi Antonelli" },
        teamPrincipal: "Toto Wolff",
        image: Mercedes,
        launchDate: ""
    },
    {
        team: "Aston Martin Honda",
        color: "#229971",
        driver1: { flag: "🇪🇸", name: "Fernando Alonso" },
        driver2: { flag: "🇨🇦", name: "Lance Stroll" },
        teamPrincipal: "Adrian Newey",
        image: AstonMartin,
        launchDate: ""
    },
    {
        team: "Alpine",
        color: "#FF87BC",
        driver1: { flag: "🇫🇷", name: "Pierre Gasly" },
        driver2: { flag: "🇦🇷", name: "Franco Colapinto" },
        teamPrincipal: "Flavio Briatore",
        image: Alpine,
        launchDate: ""
    },
    {
        team: "Audi",
        color: "#C92D4B",
        driver1: { flag: "🇩🇪", name: "Nico Hülkenberg" },
        driver2: { flag: "🇧🇷", name: "Gabriel Bortoleto" },
        teamPrincipal: "Mattia Binotto",
        image: Audi,
        launchDate: ""
    },
    {
        team: "Williams",
        color: "#64C4FF",
        driver1: { flag: "🇪🇸", name: "Carlos Sainz" },
        driver2: { flag: "🇹🇭", name: "Alex Albon" },
        teamPrincipal: "James Vowles",
        image: Williams,
        launchDate: ""
    },
    {
        team: "Racing Bulls (RB)",
        color: "#6692FF",
        driver1: { flag: "🇳🇿", name: "Liam Lawson" },
        driver2: { flag: "🇬🇧", name: "Arvid Lindblad" },
        teamPrincipal: "Alan Permane",
        image: RBV,
        launchDate: ""
    },
    {
        team: "Haas",
        color: "#B6BABD",
        driver1: { flag: "🇫🇷", name: "Esteban Ocon" },
        driver2: { flag: "🇬🇧", name: "Oliver Bearman" },
        teamPrincipal: "Ayao Komatsu",
        image: Haas,
        launchDate: ""
    },
    {
        team: "Cadillac",
        color: "#5E2750",
        driver1: { flag: "🇲🇽", name: "Sergio Pérez" },
        driver2: { flag: "🇫🇮", name: "Valtteri Bottas" },
        teamPrincipal: "Graeme Lowdon",
        image: Cadillac,
        launchDate: ""
    }
];
